import { render, staticRenderFns } from "./rel-receita-7-itens.vue?vue&type=template&id=a0465098&scoped=true&"
import script from "./rel-receita-7-itens.vue?vue&type=script&lang=js&"
export * from "./rel-receita-7-itens.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-7-itens.vue?vue&type=style&index=0&id=a0465098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0465098",
  null
  
)

export default component.exports